module.exports = (__webpack_require__("49fU"))(0);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/moment/moment.js from dll-reference vendor_library
// module id = PJh5
// module chunks = 23